import type { Board } from 'chessboard/model/board/types';
import type { Game } from 'chessboard/model/game/types';
import type { KeyedHighlight } from 'chessboard/plugins/highlights/config/types';

/**
 * Create a keyed highlight object.
 */
export function createKeyedHighlight({
  color,
  type,
  opacity,
  square,
  turn,
}: {
  color: string;
  opacity: number;
  square: Board.SanSquare;
  type: string;
  turn?: Game.ColorsAsNumbers;
}): KeyedHighlight {
  return {
    data: {
      color,
      opacity,
      square,
      turn,
      type,
    },
    key: `${type}|${square}`,
    type: 'highlight',
  };
}
